<mat-sidenav-container>
  <mat-sidenav #sidenav class="sidenav" mode="side" [opened]="true" [disableClose]="true">
    <div class="logo-container">
      <img src="/assets/img/logo.svg" style="width:100%">
    </div>
    <div class="mt-20 fx-flex fx-column justify-content-between">
      <div>
        @for (section of sections.top; track section.path) {
          <div class="fx-row align-items-center justify-content-start section-container" [routerLink]="section.path"
            [class.active]="section.active" roleBasedElement [roles]="section.roles">
            <mat-icon [class]="section.active ? 'main' : 'dark'"
              fontSet="material-icons-outlined">{{section.icon}}</mat-icon>
            <span class="text ml-5" [matBadge]="section.badge" [matBadgeDisabled]="!section.badge"
              matBadgeOverlap="false">{{section.label | translate}}</span>
          </div>
        }
      </div>
      <div>
        @for (section of sections.bottom; track section.path) {
          <div class="fx-row align-items-center justify-content-start section-container" [routerLink]="section.path"
            [class.active]="section.active" roleBasedElement [roles]="section.roles">
            <mat-icon [class]="section.active ? 'main' : 'dark'"
              fontSet="material-icons-outlined">{{section.icon}}</mat-icon>
            <span class="text ml-5" [matBadge]="section.badge" [matBadgeDisabled]="!section.badge"
              matBadgeOverlap="false">{{section.label | translate}}</span>
          </div>
        }
        @for (section of sections.admin; track section.path) {
          <div class="fx-row align-items-center justify-content-start section-container" [routerLink]="section.path"
            [class.active]="section.active" roleBasedElement [roles]="section.roles">
            <mat-icon [class]="section.active ? 'main' : 'dark'"
              fontSet="material-icons-outlined">{{section.icon}}</mat-icon>
            <span class="text ml-5" [matBadge]="section.badge" [matBadgeDisabled]="!section.badge"
              matBadgeOverlap="false">{{section.label | translate}}</span>
          </div>
        }
      </div>
    </div>
    <mat-divider class="mv-10"></mat-divider>
    <div class="fx-row align-items-center justify-content-start clickable mt-10 mb-10" [cdkMenuTriggerFor]="menu"
      [cdkMenuPosition]="positions">
      <app-avatar [user]="user" [size]="40"></app-avatar>
      <div class="fx-column ml-10 user-container">
        <span class="text user-attribute">{{user?.firstName}} {{user?.lastName}}</span>
        <span class="small light user-attribute">{{user?.email}}</span>
      </div>
    </div>
    <ng-template #menu>
      <mat-card class="menu-container p-0 elevation" cdkMenu>
        <div class="fx-column">
          <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
            [routerLink]="'settings'" cdkMenuItem>
            <mat-icon class="dark mr-5" fontSet="material-icons-outlined">settings</mat-icon>
            <span class="text">{{'NAV.SECTIONS.SETTINGS' | translate}}</span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="fx-column">
          <div class="fx-row align-items-center justify-content-start menu-item actionable clickable" (click)="logout()"
            cdkMenuItem>
            <mat-icon class="dark mr-5" fontSet="material-icons-outlined">logout</mat-icon>
            <span class="text">{{'ACTIONS.LOGOUT' | translate}}</span>
          </div>
        </div>
      </mat-card>
    </ng-template>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-progress-bar [loading]="loading" mode="indeterminate"></app-progress-bar>
    @if (user?.access; as access) {
      @if (hiddenAccessId === access.id) {
        <!-- Hidden for a demo in front of the client: nothing but the banner's icon, to show it again. -->
        <button type="button" class="access-show" id="access-banner-show"
          [attr.title]="'ACCESS.SHOW' | translate" [attr.aria-label]="'ACCESS.SHOW' | translate" (click)="hideAccessBanner(access, false)">
          <mat-icon fontSet="material-icons-outlined">badge</mat-icon>
        </button>
      } @else {
      <div class="access-banner fx-row align-items-center justify-content-between" id="access-banner" role="status">
        <div class="fx-row fx-flex align-items-center mr-10 access-banner-message">
          <mat-icon class="dark mr-8" fontSet="material-icons-outlined">badge</mat-icon>
          <span class="text bold access-banner-text">{{ accessBannerText(access) }}</span>
        </div>
        <div class="fx-row fx-shrink-0 align-items-center">
          <button type="button" class="access-banner-button" id="access-banner-change-role"
            (click)="changeAccessRole(access)">{{ 'ACCESS.CHANGE_ROLE' | translate }}</button>
          <button type="button" class="access-banner-button ml-8" id="access-banner-leave"
            [disabled]="leavingAccess" (click)="leaveAccess()">{{ 'ACCESS.LEAVE' | translate }}</button>
          <button type="button" class="access-banner-fold ml-8" id="access-banner-hide"
            [attr.title]="'ACCESS.HIDE' | translate" [attr.aria-label]="'ACCESS.HIDE' | translate" (click)="hideAccessBanner(access, true)">
            <mat-icon class="dark">expand_less</mat-icon>
          </button>
        </div>
      </div>
      }
    }
    <div class="router-container" [class.with-access-banner]="!!user?.access && hiddenAccessId !== user?.access?.id">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (uploadPanel) {
  <app-upload-panel class="upload-panel"></app-upload-panel>
}